import React, { useEffect, useState } from 'react'
import { MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';

import { firestore } from '../../../firebase';

function ImagePicker(props) {

    const [media, setMedia] = useState([]);
    const [mediaLoading, setMediaLoading] = useState(true)
    const [showMedia, setShowMedia] = useState(false)
    const [mediaPage, setMediaPage] = useState(1);
    const [refresh, setRefresh] = useState(0)
    const [perPage, setPerPage] = useState(12)

    const [error, setError] = useState("");


    useEffect(() => {

        
        async function fetchImages() {
            setMediaLoading(true)
            try {

                const imagesRef = firestore.collection("images");
                imagesRef.orderBy("createdAt", "desc").onSnapshot(({docs}) => {
                    const images = docs.map(doc => {
                        return {id: doc.id, ...doc.data()}
                    })
                    setMedia(images)
                })
            } catch (error) {
                console.log("Kunne ikke hente media")
            }
            setMediaLoading(false)

        } 
        fetchImages()

    }, [perPage, refresh])

    function toggleMedia() {
        if (showMedia) {
            setShowMedia(false)
        } else {
            setShowMedia(true)
        }
    }

    function refreshMedia() {
        setPerPage(perPage+1)
        
    }

    async function addImageAlbum(e, imageUrl) {
        e.preventDefault();
        try {

            const albumImagesRef = firestore.collection("albums").doc(props.albumId).collection("images");
            const data = {
                imageUrl: imageUrl,
                createdAt: new Date().toISOString()
            }
            console.log(data)
            albumImagesRef.add(data)
        } catch (error) {
            console.log(error)
        }
    }
    async function removeImageAlbum(e, imageId) {
        e.preventDefault();
        console.log("removeHandler")
        try {
            const imageRef = firestore.collection("albums").doc(props.albumId).collection("images").doc(imageId);
            imageRef.delete();
            console.log("deleted")
        } catch (error) {
            console.log(error)
            setError(error.message)
        }
    }


    return (
        <div>


            <MDBBtn className="btn btn-rounded btn-success" onClick={toggleMedia}>Picture gallery</MDBBtn>
            <MDBModal size="fluid" isOpen={showMedia} toggle={toggleMedia}>
                <MDBModalHeader toggle={toggleMedia}>Galleri</MDBModalHeader>
                <MDBModalBody>
                <>
                    {mediaLoading ? "Laster...." : 
                    
                    <> 
                    
                        <div className="row">
                            {media.map(image => {
                                return (
                                    <figure key={image.id} className="col-md-4 col-lg-3 col-xl-2 my-3">
                                        {props.type === "album" ? 
                                        <React.Fragment>
                                            {props.images.includes(image.imageUrl) ? (
                                                <div onClick={(e) => removeImageAlbum(e, image.id)} className={props.images.includes(image.imageUrl) ? "border-success" : "border-danger"}>
                                                    
                                                    <img src={image.imageUrl} className="img-fluid fixed-image-wide"  />
                                                    {props.images.includes(image.imageUrl) && <p>Valgt</p>}
                                                    {error && <div className="alert alert-danger">{error}</div>}
                                                    
                                                </div>
                                            ) : (
                                                <div onClick={(e) => addImageAlbum(e, image.imageUrl)} className={props.images.includes(image.imageUrl) ? "border-success" : "border-danger"}>
                                                    
                                                    <img src={image.imageUrl} className="img-fluid fixed-image-wide"  />
                                                    {props.images.includes(image.imageUrl) && <p>Valgt</p>}
                                                    
                                                </div>
                                            )                                       
                                            }

                                        </React.Fragment>
                               
                                        : <img src={image.imageUrl} className="img-fluid fixed-image-wide" />}                                     
                                    </figure>
                                )
                            })}
                        </div>
                        <div className="col-12">
                            <div className="my-3">
                                <div className="btn btn-sm btn-rounded btn-info" onClick={refreshMedia}>Refresh</div>
                                <p>For å vise alle bilder kreves ekstra rettigheter</p>
                            </div>
                            <div className="btn btn-lg btn-success btn-rounded" onClick={() => setPerPage(perPage+12)}>Eldre bilder</div>
                        </div>
                    </>
                    }

                </>
                </MDBModalBody>
                <MDBModalFooter>
                <MDBBtn color="secondary" onClick={toggleMedia}>Close</MDBBtn>
                </MDBModalFooter>
            </MDBModal>
        </div>
    )
}
export default ImagePicker